<template>
    <div class="page container dynamicDataPage" data-page="Posts">

        <!--Breadcrumbs-->
        <div class="breadcrumbs">
            <router-link to="/">Home</router-link>
            <span class="divider"><ion-icon name="chevron-forward"></ion-icon></span>
            <router-link to="/posts">Posts</router-link>
        </div>

        <div class="pure-g">
            <!--LEFT-->
            <div class="pure-u-1 pure-u-lg-5-24 leftArea">
                
                <!--Create New Post-->
                <template v-if="$store.state.currentUser !== null">
                    <a href="#0" class="btn green" @click.prevent="openPostModal">Create Post</a>
                    <Modal
                        ref="newPostModal"
                        title="New Post"
                        @close="closePostModal"
                    >
                        <div class="postForm formArea">
                            <form v-if="!form.success" @submit="addPost" action="" method="post">
                                
                                <!-- <input v-model="form.fields.title.value" type="text" placeholder="Title" :class="{error: form.errors.title}" /> -->
                                
                                <textarea v-model="form.fields.description.value" :placeholder="`What's on your mind, ${$store.state.userProfile.firstName}?`" :class="{error: form.errors.description}"></textarea>

                                <FileUpload
                                    :key="`file_uploader_${form.fileUploaderKey}`"
                                    ref="fileUpload"
                                    :path="'files/'"
                                    :hide="true"
                                    :uid="$store.state.currentUser.uid"
                                    @upload-success="syncAllUploadedFiles"
                                    @delete-success="removedFile"
                                ></FileUpload>

                                <!--Files-->
                                <div v-if="form.files.length > 0" class="pure-g files">
                                    <div
                                        v-for="(file, fileIndex) in form.files" :key="`file_${fileIndex}`"
                                        class="pure-u-1-2 pure-u-md-1-4 pure-u-lg-1-6 file"
                                    >
                                        <template v-if="file.type === 'video'">
                                            <div class="fileItem small video image" :style="`background-image:url(${file.poster.url});`">
                                                <video :src="`${file.url}`"></video>
                                                <a @click.prevent="$refs.fileUpload.deleteFiles(file)" class="btn secondary icon-only"><ion-icon name="trash"></ion-icon></a>
                                            </div>
                                        </template>

                                        <template v-else-if="file.type === 'image'">
                                            <div class="fileItem small image" :style="`background-image:url(${file.medium.url});`">
                                                <a @click.prevent="$refs.fileUpload.deleteFiles(file)" class="btn secondary icon-only"><ion-icon name="trash"></ion-icon></a>
                                            </div>
                                        </template>

                                        <template v-else-if="file.type === 'other'">
                                            <div class="fileItem small other">
                                                <ion-icon name="document"></ion-icon>
                                                <a @click.prevent="$refs.fileUpload.deleteFiles(file)" class="btn secondary icon-only"><ion-icon name="trash"></ion-icon></a>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                                
                                <!--Action Btns-->
                                <div class="clearfix">
                                    <div class="col-2 float-left px-1">
                                        <a 
                                            href="#0"
                                            @click.prevent="$refs.fileUploadInput.click()"
                                            class="btn secondary icon-left full hint hint--top"
                                            data-hint="Photo / Video"
                                        >
                                            <template v-if="!form.filesLoading">
                                                <ion-icon name="images"></ion-icon>
                                            </template>
                                            <div v-else class="loading small"></div>
                                        </a>
                                        <input type="file" ref="fileUploadInput" multiple="multiple" class="fileUploadInput hidden" @change="customInputFilesHandler" v-show="false" />
                                    </div>
                                    <div class="col-10 float-left px-1">
                                        <input type="submit" value="Post" class="btn green submitBtn" />
                                    </div>
                                </div>

                                <!--Error Msg-->
                                <div v-if="Object.keys(form.errors).length > 0" class="msg error">
                                    <p>Please fill all required fields.</p>
                                </div>

                            </form>
                            <div v-else class="successArea">
                                <div>
                                    <ion-icon name="checkmark-circle"></ion-icon>
                                    <h3>Successfully created!!!</h3>
                                    <p>Your post was successfully created.</p>
                                </div>
                            </div>
                        </div>
                    </Modal>
                </template>
            </div>

            <!--CENTER-->
            <div class="pure-u-1 pure-u-lg-14-24 centerArea">
                <!--Posts List-->
                <div v-if="posts.length > 0" class="items" data-type="posts">
                    
                    <div :id="item.id" v-for="item in posts" :key="item.id" class="item" data-type="posts" :data-post-type="item.type">

                        <!--Header-->
                        <div class="item_header">

                            <div v-if="item.type !== 'link'" class="item_block">
                                <div class="avatar medium" :style="`background-image:url(${$store.state.allUsers[item.uid].photoURL});`">
                                    <MemberStatus :memberId="item.uid"></MemberStatus>
                                </div>
                            </div>
                            <div class="item_block">
                                <h3 v-if="item.title" class="itemTitle">{{ item.title }}</h3>
                                <div class="itemInfo">
                                    <div>
                                        <p v-if="item.type !== 'link'">
                                            <span class="itemAuthorName">{{ $store.state.allUsers[item.uid].firstName }}</span>
                                        </p>
                                        <p>
                                            <span v-if="item.timestamp" class="itemDate">{{ item.timestamp.toDate() | postDate }}</span>
                                            <span v-if="item.category" class="badge itemCategory">{{ item.category | removeSpace }}</span>
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>
                        
                        <!--Content-->
                        <div
                            class="item_center"
                            :class="getDynamicClass(item)"
                        >
                            <div class="itemContent">
                                
                                <!--Text-->
                                <p class="textField">{{ item.description }}</p>

                                <!--Files-->
                                <template v-if="item.files">
                                    <template v-if="item.files.length === 1">
                                        <!-- <img class="imageField" :src="item.files[0].original.url" /> -->
                                        <div class="imageField image image_1" :style="`background-image:url(${item.files[0].original.url});`"></div>
                                    </template>
                                    <template v-else-if="item.files.length === 4">
                                        <div class="grid-layout files">
                                            <div v-for="(image, imageIndex) in item.files" :key="`image_${image.id}_${imageIndex}`" class="grid-item">
                                                <div class="userFileItem">
                                                    <div class="image" :style="`background-image:url(${image.original.url});`"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </template>

                                <!--Videos-->
                                <template v-if="item.type === 'video'">
                                    <div class="embedType">
                                        <vue-plyr>
                                            <div :data-plyr-provider="item.data.type.toLowerCase()" :data-plyr-embed-id="item.data.id"></div>
                                        </vue-plyr>
                                    </div>
                                </template>

                                <!--Link-->
                                <template v-if="item.type === 'link'">
                                    <a :href="item.url" target="_blank" class="itemLink">
                                        <img class="imageField" :src="item.urlToImage" />
                                    </a>
                                </template>

                            </div>
                        </div>

                        <!--Footer-->
                        <div class="item_footer">

                            <template v-if="item.type !== 'link'">
                                <div v-if="$store.state.currentUser.uid === item.uid" class="actionBtns">
                                    <a href="#0" class="delete" @click.prevent="deletePost(item.id)">
                                        <ion-icon name="trash"></ion-icon>
                                    </a>
                                </div>
                                
                                <Comments
                                    :isSmall="true"
                                    :type="'posts'"
                                    :isOpen="true"
                                    :collectionId="'posts'"
                                    :docId="item.id"
                                    :key="item.id"
                                ></Comments>
                            </template>
                        </div>
                    </div>
                    
                </div>
                <div v-else class="empty">
                    <p>No posts here yet...</p>
                </div>

            </div>
            
            <!--RIGHT-->
            <div class="pure-u-1 pure-u-lg-5-24 rightArea">

            </div>
        </div>

    </div>
</template>

<script>
import moment from 'moment'
const fb = require('@/firebaseConfig.js')
import Modal from '@/components/modals/Modal'
import Comments from '@/components/Comments'
import MemberStatus from '@/components/MemberStatus'
import FileUpload from '@/components/uploader/FileUpload'

export default {
    name: 'Posts',

    components: {
        Modal,
        Comments,
        MemberStatus,
        FileUpload
    },

    data(){
        return{
            posts: [],
            form: {
                fields: {
                    title: {
                        required: false,
                        value: ''
                    },
                    description: {
                        required: true,
                        value: ''
                    },
                },
                fileUploaderKey: 0,
                files: [],
                filesLoading: false,
                errors: {},
                success: false
            },
        }
    },

    async mounted(){
        await this.$bind('posts', fb.db.collection('posts').orderBy('timestamp', 'desc'))
        // this.getNewsPosts()
    },

    methods: {
        resetForm(){
            this.form = {
                fields: {
                    title: {
                        required: false,
                        value: ''
                    },
                    description: {
                        required: true,
                        value: ''
                    },
                },
                fileUploaderKey: 0,
                files: [],
                filesLoading: false,
                errors: {},
                success: false
            }
        },

        addPost(e){
            e.preventDefault()

            this.form.errors = {}
            this.form.success = false
            
            let post = {
                uid: this.$store.state.currentUser.uid,
                timestamp: fb.firebase.firestore.FieldValue.serverTimestamp(),
                type: 'text'
            }


            // Check for form errors
            Object.keys(this.form.fields).forEach(key => {

                let field = this.form.fields[key]

                // General Fields
                if(field.required && field.value === ''){
                    this.form.errors[key] = true
                }else{
                    post[key] = field.value
                }
            })
            if(this.form.files.length > 0){
                let postFiles = []
                for(let i = 0; i < this.form.files.length; i++){
                    let file = this.form.files[i]
                    delete file.timestamp
                    postFiles.push(file)
                }
                post.files = postFiles
            }

            // Return if form errors exist
            if(Object.keys(this.form.errors).length > 0) return



            // Add to Firestore
            fb.db.collection('posts').add(post).then(doc => {

                console.log('Added new post with id: ', doc.id)

                this.$notify({
                    group: 'globalNotifications',
                    title: `Successfully added a new post "${post.description.value}"`
                })

                this.resetForm()

            }).catch(err => {
                console.log('Error adding a new post: ', err)
                
                this.form.errors = {
                    newError: 'Error creating a new post!'
                }
            })
        },

        deletePost(id){
            if(confirm('Are you sure you want to delete this post?')){
                fb.db.collection('posts').doc(id).delete().then(() => {
                    this.$notify({
                        group: 'globalNotifications',
                        title: `Successfully removed a post`
                    })
                })
            }
        },

        removedFile(fileId){
            let newFiles = this.form.files.filter(file => {
                return file.id !== fileId
            })

            this.form.files = newFiles
        },

        syncAllUploadedFiles(files){

            console.log('Finished uploading and generating all files: ', files)
 
            for(let i = 0; i < files.length; i++){
                this.form.files.push(files[i])
            }

            this.form.fileUploaderKey += 1
            this.filesLoading = false
        },

        customInputFilesHandler(e){
            let droppedFiles = e.target.files
            if(!droppedFiles) return
            this.filesLoading = true
            this.$refs.fileUpload.addFilesToPond(droppedFiles)
        },

        // News
        getNewsPosts(){

            let key = '7daf3a091c1d45999314f212825aad9b'
            let country = 'us'
            let cors = 'https://cors-anywhere.herokuapp.com/'
            let reqUrl = `${cors}http://newsapi.org/v2/top-headlines?country=${country}&apiKey=${key}`

            console.log('Posts: ', this.posts)

            this.$http.get(reqUrl).then(res => {
                if(res.status === 200){
                    let articles = res.body.articles

                    console.log('Got news data: ', articles)

                    for(let i = 0; i < articles.length; i++){
                        let news = articles[i]
                        news.type = 'link'
                        news.id = `news_${i}`

                        this.posts.push(news)
                    }
                }
            }).catch(err => {
                console.log('Error getting news data: ', err)  
            })
        },

        // Helpers
        getDynamicClass(item){
            let classes = item.type + ' '

            if(item.type === 'text'){
                if(typeof item.files === 'undefined' && typeof item.description !== 'undefined'){
                    if(item.description.length < 100){
                        classes += 'onlyText '
                    }else{
                        classes += 'large '
                    }
                }
            }

            return classes
        },

        // Modals
        openPostModal(){
            this.$refs.newPostModal.open()
        },
        closePostModal(){
            console.log('On Modal Close!')
        }
    },

    filters: {
        postDate(val){
            return moment(val).format('MMM DD, h:mm a')
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/Posts/Posts.vue